import { render, staticRenderFns } from "./StartOver.vue?vue&type=template&id=4c3fc713&scoped=true"
import script from "./StartOver.vue?vue&type=script&lang=js"
export * from "./StartOver.vue?vue&type=script&lang=js"
import style0 from "./StartOver.vue?vue&type=style&index=0&id=4c3fc713&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3fc713",
  null
  
)

export default component.exports